@keyframes skel {
  50% {
    opacity: 0.55;
  }
}

.root {
  display: block;
  background: var(--sunk);
  animation: skel 1.4s ease-in-out infinite;
}
